import BtnConnect from '../images/btn_connect.png';
import Icon from '../images/ico_earth.svg';
import Arrow from '../images/ico_arrowdown.svg';
import { useSelector } from "react-redux";

export default function SubNavigation(props) {
  const blockchain = useSelector((state) => state.blockchain);
  // プルダウンメニュー作るのが面倒臭い😫
  function toggleLang(e) {
    if (props.lang === "ja") {
      props.toggleLang("en");
    } else {
      props.toggleLang("ja");
    }
  }

  return (
    <>
      <div className="subnavigation">
        {/* 言語切替 */}
        <button className="subnavigation__lang" onClick={toggleLang}>
          <img src={Icon} alt="Earth" className='subnavigation__earth' />
          <span>{props.lang}</span>
          <img src={Arrow} alt="" className='subnavigation__arrow' />
        </button>

        {/* Wallet Connect */}
        {blockchain.account !== "" && blockchain.smartContract !== null ?
          <small>{`${blockchain.account.slice(0, 7)}...${blockchain.account.slice(-7)}` }</small>:
          <button className="btn btn__connect" onClick={props.connectClick}>
            <img src={BtnConnect} alt="Wallet Connect" />
          </button>
        }
      </div>
    </>
  );
}

